<template>
  <BaseLayout :pageTitle="title">
    <div class="registered">
      <div class="h f-y-center m-b-55 m-l-75 m-r-75">
        <img class="RegisteredLogoImage" src="./assets/registered-logo.png" />
        <div class="f-x-center f-column">
          <div class="title m-b-15">欢迎使用律小购</div>
          <div class="label">法律人工智能服务平台</div>
        </div>
      </div>
      <div class>
        <div class="login-input-box">
          <img class="registeredInputNameImage icon" src="./assets/registered-input-name.png" />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'account'}"
            :ref="el => nodes.accountNode.value = el"
            :value="form.account"
            @input="(e) => onInputChange('account', e)"
            @blur="accountBlurEvent"
            placeholder="设置登录账号(建议使用email)"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredInputPasswordImage icon"
            src="./assets/registered-input-password.png"
          />
          <input
            type="password"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'password'}"
            :ref="el => nodes.passwordNode.value = el"
            @keydown="noSpaces($event)"
            :value="form.password"
            @input="(e) => onInputChange('password', e)"
            @blur="passwordBlurEvent"
            placeholder="设置您的登录密码"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredInputPasswordImage icon"
            src="./assets/registered-input-password.png"
          />
          <input
            type="password"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'confirmPassword'}"
            :ref="el => nodes.confirmPasswordNode.value = el"
            :value="form.confirmPassword"
            @input="(e) => onInputChange('confirmPassword', e)"
            @keydown="noSpaces($event)"
            placeholder="再次输入密码"
            @blur="confirmPasswordBlurEvent"
          />
        </div>
        <div class="login-input-box">
          <img class="registeredInputPhoneImage icon" src="./assets/registered-input-phone.png" />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'mobile'}"
            :ref="el => nodes.mobileNode.value = el"
            v-model="form.mobile"
            placeholder="输入您的手机号"
            @blur="mobileBlurEvent"
          />
        </div>
        <div class="login-input-box">
          <img
            class="registeredVerificationCodeImage icon"
            src="./assets/registered-verification-code.png"
          />
          <input
            type="text"
            class="input p-l-100"
            :class="{'input-error' : requiredErrorKey === 'mobileVerificationCode'}"
            :ref="el => nodes.mobileVerificationCodeNode.value = el"
            v-model="form.mobileVerificationCode"
            placeholder="输入验证码"
            @blur="codeBlurEvent"
          />
          <div v-if="remainingTime == null" class="code" @click="getCodeAction">获取验证码</div>
          <div v-else class="code-disabled">{{remainingTime}}后可重新发送</div>
        </div>
      </div>

      <div class="login-input-box m-b-50">
        <div class="submit" @click="submitEvent">注&nbsp;&nbsp;&nbsp;册</div>
      </div>

      <div class="f-center modal-overlay" v-if="userTermsShow" @click="() => userTermsShow = false">
        <div class="overlay-box btn-radius overflow-y-scroll h-80b w-80b">
          <UserTerms class="overflow-y-scroll" />
        </div>
      </div>

      <div
        class="f-center modal-overlay"
        v-if="privacyTermsShow"
        @click="() => privacyTermsShow = false"
      >
        <div class="overlay-box btn-radius overflow-y-scroll h-80b w-80b">
          <PrivacyTerms class="overflow-y-scroll" />
        </div>
      </div>

      <div
        class="f-center modal-overlay"
        v-if="tariffTermsShow"
        @click="() => tariffTermsShow = false"
      >
        <div class="overlay-box btn-radius overflow-y-scroll h-80b w-80b">
          <TariffTerms class="overflow-y-scroll" />
        </div>
      </div>

      <div class="terms">
        <ion-checkbox v-model="checked" mode="md" class="m-r-10" color="primary"></ion-checkbox>
        <span class="f-1">
          注册即代表您已阅读并同意
          <span>
            <span class="link" @click="() => userTermsShow = true">《服务协议》</span>
            <span>、</span>
            <br />
            <span class="link" @click="() => privacyTermsShow = true">《隐私条款》</span>
            <span>和</span>
            <span class="link" @click="() => tariffTermsShow = true">《价格条款》</span>
            <span>。</span>
          </span>
        </span>
      </div>

      <!-- <div class="to-login">
      <span>已经有账号了？</span>
      <span class="link" @click="toLogin">立刻登录</span>
      </div>-->
    </div>
  </BaseLayout>
</template>

<script>
import { userApi } from '@/apis'
import { toast } from '@/utils/alert'
import { onMounted, reactive, ref } from 'vue'
import md5 from 'crypto-js/md5'
import PrivacyAndAgreement from '@/view/user/PrivacyAndAgreement.vue'
import PrivacyTerms from '@/view/user/PrivacyTerms.vue'
import TariffTerms from '@/view/user/TariffTerms.vue'
import UserTerms from '@/view/user/UserTerms.vue'
import router from '@/router'
import { useRoute } from 'vue-router'
const isEmailRe = new RegExp(
  '^[A-Za-z0-9-_]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$',
  'g'
)

export default {
  setup() {
    const route = useRoute()

    const userType = route.query.userType || 'lawOffice'
    const titles = {
      lawOffice: '律所开户',
      lawyer: '律师注册',
      individual: '用户注册',
    }
    const title = ref(titles[userType])

    document.getElementsByTagName('title')[0].innerText = title.value

    const nodes = {
      accountNode: ref(null),
      mobileNode: ref(null),
      passwordNode: ref(null),
      confirmPasswordNode: ref(null),
      mobileVerificationCodeNode: ref(null),
    }

    const requiredErrorKey = ref('')

    const verify = {
      account: {
        isRequired: true,
        v: () =>
          /(?=.*\d+)^[a-zA-Z]\w{3,7}$/g.test(form.account) ||
          /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
            form.account
          ),
        msg: '账号设置字母开头包含字母和数字4-18位或邮箱',
      },
      password: {
        isRequired: true,
        v: () => /^[0-9A-Za-z]{1,8}$/.test(form.password),
        msg: '密码设置字母和数字1-8位',
      },
      confirmPassword: {
        isRequired: true,
        v: () => form.password == form.confirmPassword,
        msg: '两次密码不一致',
      },
      mobile: {
        isRequired: true,
        v: () => /^[1]([3-9])[0-9]{9}$/.test(form.mobile),
        msg: '手机号码设置有误',
      },
    }

    const form = reactive({
      account: '', // 账号
      mobile: '', // 手机号码
      mobileVerificationCode: '', // 手机验证码
      password: '',
      confirmPassword: '',
    })

    const privacyTermsShow = ref(false)
    const userTermsShow = ref(false)
    const tariffTermsShow = ref(false)

    const checked = ref(false)

    const remainingTime = ref(null)

    const accountBlurEvent = () => {
      // console.log('--accountBlurEvent--', form.account, verify.account.v())
      if (!form.account) {
        return
      }
      if (verify.account.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'account'
        toast(verify.account.msg)
      }
    }
    const passwordBlurEvent = () => {
      if (!form.password) {
        return
      }
      if (verify.password.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'password'
        toast(verify.password.msg)
      }
    }

    const confirmPasswordBlurEvent = () => {
      if (!form.confirmPassword) {
        return
      }
      if (verify.confirmPassword.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'confirmPassword'
        toast(verify.confirmPassword.msg)
      }
    }
    const mobileBlurEvent = () => {
      if (!form.mobile) {
        return
      }
      if (verify.mobile.v()) {
        requiredErrorKey.value = ''
      } else {
        requiredErrorKey.value = 'mobile'
        toast(verify.mobile.msg)
      }
    }

    const codeBlurEvent = () => {
      if (!form.mobileVerificationCodeNode) {
        return
      }
      requiredErrorKey.value = ''
    }

    const onInputChange = (key, e) => {
      const value = e.target.value.toLowerCase().trim()
      form[key] = value
    }

    const timerAction = (time) => {
      if (remainingTime.value === null) {
        remainingTime.value = time
      }
      setTimeout(() => {
        remainingTime.value--
        if (remainingTime.value === 0) {
          remainingTime.value = null
          return
        }
        timerAction(time)
      }, 1000)
    }

    const sms = ref('')

    const getCodeAction = async () => {
      if (!form.mobile) {
        toast('填写手机号码')
        return
      }

      const registeredSms = await userApi.registeredSms({ mobile: form.mobile })
      sms.value = registeredSms.msg
      timerAction(60)
    }

    const submitEvent = async () => {
      console.log('submitEvent')
      const verifyKeys = Object.keys(verify)
      const requiredKey = verifyKeys.find((key) => form[key] == '')
      const verifyKey = verifyKeys.find((key) => !verify[key].v())
      if (requiredKey || verifyKey) {
        console.log(verifyKey, requiredKey)
        const key = verifyKey || requiredKey
        requiredErrorKey.value = key
        if (verifyKey == requiredKey) {
          const node = nodes[`${key}Node`]
          node.value.focus()
        } else if (verifyKey != requiredKey) {
          toast(verify[verifyKey].msg)
          const node = nodes[`${key}Node`]
          node.value.focus()
        } else {
          const node = nodes[`${key}Node`]
          node.value.focus()
        }
        return
      }

      if (checked.value == false) {
        toast('请阅读并同意服务协议和隐私条款')
        return
      }

      const account = form.account.toLowerCase()
      const ajaxs = {
        lawOffice: userApi.registeredLawOffice,
        lawyer: userApi.registered,
        individual: userApi.registered,
      }
      const appendBodys = {
        lawOffice: {},
        lawyer: {
          inviterSsoAccountRoleId: route.query.inviterSsoAccountRoleId,
        },
        individual: {
          inviterSsoAccountRoleId: route.query.inviterSsoAccountRoleId,
        },
      }
      console.log('appendBodys[userType]', appendBodys[userType])
      const registered = await ajaxs[userType]({
        account: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          account
        )
          ? null
          : account,
        email: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/g.test(
          account
        )
          ? account
          : null,
        md5Pwd: md5(form.password).toString(),
        mobile: form.mobile,
        mobileVerificationCode: form.mobileVerificationCode,
        registerSourceAccountId: route.query.registerSourceAccountId || null,
        inviterRoleId: userType == 'individual' ? 17 : 16,
        ...appendBodys[userType],
      })
      router.push({
        path: '/registeredFulfill',
        query: {
          userType: route.query.userType,
        },
      })
    }

    const toLogin = () => router.push('/login')

    onMounted(() => {})
    return {
      title,
      nodes,
      form,
      verify,
      submitEvent,
      requiredErrorKey,
      getCodeAction,
      privacyTermsShow,
      userTermsShow,
      tariffTermsShow,
      checked,
      remainingTime,
      accountBlurEvent,
      passwordBlurEvent,
      onInputChange,
      confirmPasswordBlurEvent,
      mobileBlurEvent,
      codeBlurEvent,
      toLogin,
      sms,
    }
  },
  components: { PrivacyTerms, UserTerms, TariffTerms },
}
</script>

<style lang="scss">
@import './utils.scss';
.registered {
  display: flex;
  flex-direction: column;
  padding-top: 80px;
  background: #fff;
  height: 100%;
  ion-checkbox {
    --size: 36px;
  }
  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .overlay-box {
    position: relative;
    z-index: 10000;
  }
  .RegisteredLogoImage {
    width: 94px;
    height: 112px;
    margin-right: 30px;
  }
  .to-login {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 75px;
    color: #a2a2a2;
    font-size: 28px;
    .link {
      color: #3370ff;
    }
  }
  .terms {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #1f2329;
    font-size: 26px;
    padding-left: 75px;
    padding-right: 75px;
    .link {
      color: #3370ff;
    }
  }
}
</style>